<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GszFO5/tc-custom/9780801897801.jpg?1695285910376" alt="This image is the cover for the book After the Gold Rush, Revisiting Rural America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">After the Gold Rush, Revisiting Rural America
      </h1>
      <p class="bookDescription body article font2">
        <b>A dramatic history of a group of families in post-gold rush California who turned to agriculture when mining failed.</b><br/><br/>“It is a glorious country,” exclaimed Stephen J. Field, the future U.S. Supreme Court justice, upon arriving in California in 1849. Field’s pronouncement was more than just an expression of exuberance. For an electrifying moment, he and another 100,000 hopeful gold miners found themselves face-to-face with something commensurate to their capacity to dream. Most failed to hit pay dirt in gold. Thereafter, one illustrative group of them struggled to make a living in wheat, livestock, and fruit along Putah Creek in the lower Sacramento Valley. Like Field, they never forgot that first “glorious” moment in California when anything seemed possible.<br/><br/>In <i>After the Gold Rush</i>, David Vaught examines the hard-luck miners-turned-farmers—the Pierces, Greenes, Montgomerys, Careys, and others—who refused to admit a second failure, faced flood and drought, endured monumental disputes and confusion over land policy, and struggled to come to grips with the vagaries of local, national, and world markets.<br/><br/>Their dramatic story exposes the underside of the American dream and the haunting consequences of trying to strike it rich.<br/><br/><b>“An excellent history of farming in the Sacramento Valley in the late nineteenth century.” —<i>California History</i></b><br/><br/><b>“Vaught tells a riveting story of two generations of farmers who “committed themselves not only to the market but to community life as well.” He argues that these twin commitments, born of their failures in the gold fields, were an essential part of the culture of American capitalism that emerged in the second half of the nineteenth century.” —<i>Business History Review</i></b><br/><br/><b>“Vaught set himself the goal of writing a “new” rural history of California, examining the state’s wheat farmers in their social and cultural contexts. In <i>After the Gold Rush</i>, he achieves his goal admirably.” —<i>Journal of American History</i></b><br/><br/><b>“An agricultural history that weaves together an unpredictable creek, a fluctuating market, and the perseverance of the American Dream.” —<i>Journal of Interdisciplinary History</i></b><br/><br/><b>2008 Winner of the Albert J. Beveridge Award of the American Historical Association</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Vaught
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?690af9c4